import { Axios_Get } from "../../axios";
/* Interfaces */
import { StatisticsInterface } from ".";

export const API_STATISTICS = "/v1/pdgStorageStatsGETSvc";

export const getStatistics = async (): Promise<StatisticsInterface> => {
  return Axios_Get<StatisticsInterface>(API_STATISTICS);
};
